export const linkUrl = "https://dental.asianoralcare.com.np/api"
export const imgUrl = "https://dental.asianoralcare.com.np/"

